<template>
  <div id="myDiv">
    <div v-if="userAcc === 'betagrodemo' || admin == 'betagrodemo'">
      <vs-breadcrumb>
        <li>
          <a
            aria-current="page"
            style="color: #ffffff"
            title="Device Management"
            >Device Management</a
          ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
        </li>
        <li>
          <router-link style="color: #ffffff" :to="'IndoorAlert'" title="Alert"
            >Alert</router-link
          ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="textSuccess">View Alert</li>
      </vs-breadcrumb>
      <vs-row>
        <vs-card style="border-radius: 20px">
          <div class="mt-2 textSuccess" slot="header">
            <vs-row>
              <h4>{{ dataAlert.alertname }}</h4>
            </vs-row>
          </div>

          <vs-row class="mt-2" vs-w="12">
            <vs-col
              v-if="dataAlert.alertstatus"
              class="mt-4 mb-2"
              vs-lg="1"
              vs-sm="2"
              vs-xs="3"
            >
              <div class="d-flex flex-column bd-highlight mb-3">
                <div class="p-2 bd-highlight">
                  <vs-icon
                    icon="notifications_active"
                    color="warning"
                    size="75px"
                  ></vs-icon>
                </div>
                <div class="p-2 bd-highlight">
                  <vs-button
                    class="mt-1 align-self-center"
                    icon="notifications_off"
                    size="small"
                    type="border"
                    @click="disarm"
                    style="width: 76px"
                    color="warning"
                    >Disarm</vs-button
                  >
                </div>
              </div>
            </vs-col>
            <vs-col
              v-else
              class="center mt-4 mb-2"
              vs-lg="1"
              vs-sm="2"
              vs-xs="3"
            >
              <vs-icon
                icon="notifications_off"
                color="light"
                size="75px"
              ></vs-icon>
            </vs-col>
            <vs-col
              class="mb-2 mt-2"
              vs-type="flex"
              vs-align="center"
              vs-lg="5"
              vs-sm="10"
              vs-xs="9"
            >
              <div id="divSizeResponsive" style="width: 100%">
                <vs-row vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Alert ID</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">{{ dataAlert.alertid }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Alert name</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">{{
                      dataAlert.alertname
                    }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Timestamp</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">
                      {{
                        $moment(dataAlert.timestamp).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      }}</span
                    >
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Status</span
                    >
                  </vs-col>
                  <vs-col
                    class="p-0"
                    v-if="dataAlert.alertstatus"
                    vs-lg="8"
                    vs-sm="8"
                    vs-xs="7"
                  >
                    <span id="textSizeResponsive">Armed</span>
                  </vs-col>
                  <vs-col v-else class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">Disarmed</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Condition</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">{{ dataAlert.message }}</span>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-row>
      <vs-row>
        <vs-card style="border-radius: 20px">
          <vs-row>
            <h5 id="center" class="mt-2 mr-2">Sensor :</h5>
            <h5>
              <vs-button
                @click="viewSensor"
                icon="signal_cellular_alt"
                type="flat"
                >{{ dataAlert.sensorid }} {{ dataAlert.sensorname }}</vs-button
              >
            </h5>
          </vs-row>
          <br />
          <h6 class="mb-3">Reading Data</h6>
          <vs-table :data="Object.keys(dataAlert.lastdata[0])">
            <template slot="thead">
              <vs-th
                style="background: #484848; color: #ffffff"
                v-for="(data, index) in Object.keys(dataAlert.lastdata[0])"
                :key="index"
                >{{ data }}</vs-th
              >
              <vs-th
                style="background: #484848; color: #ffffff; width: 500px"
                v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
              >
              </vs-th>
              <vs-th
                style="background: #484848; color: #ffffff"
                v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
              >
              </vs-th>
              <vs-th
                style="background: #484848; color: #ffffff"
                v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
              >
              </vs-th>
              <vs-th
                style="background: #484848; color: #ffffff"
                v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
              >
              </vs-th>
              <vs-th
                style="background: #484848; color: #ffffff"
                v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
              >
              </vs-th>
            </template>
            <template>
              <vs-tr style="background: #212121; color: #ffffff">
                <vs-td
                  v-for="data in Object.keys(dataAlert.lastdata[0])"
                  :key="data"
                >
                  {{ dataAlert.lastdata[0][data] }}
                </vs-td>
                <vs-td
                  style="width: 500px"
                  v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
                >
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-row>
    </div>
    <div v-else>
      <vs-breadcrumb>
        <li>
          <a
            aria-current="page"
            style="color: rgba(0, 0, 0, 0.4)"
            title="Device Management"
            >Device Management</a
          ><span class="vs-breadcrum--separator">/</span>
        </li>
        <li>
          <router-link :to="'alert'" title="Alert">Alert</router-link
          ><span class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="textSuccess">View Alert</li>
      </vs-breadcrumb>
      <vs-row>
        <vs-card style="border-radius: 20px">
          <div class="mt-2" slot="header">
            <vs-row>
              <h4>{{ dataAlert.alertname }}</h4>
            </vs-row>
          </div>

          <vs-row class="mt-2" vs-w="12">
            <vs-col
              v-if="dataAlert.alertstatus"
              class="mt-4 mb-2"
              vs-lg="1"
              vs-sm="2"
              vs-xs="3"
            >
              <div class="d-flex flex-column bd-highlight mb-3">
                <div class="p-2 bd-highlight">
                  <vs-icon
                    icon="notifications_active"
                    color="warning"
                    size="75px"
                  ></vs-icon>
                </div>
                <div class="p-2 bd-highlight">
                  <vs-button
                    class="mt-1 align-self-center"
                    icon="notifications_off"
                    size="small"
                    type="border"
                    @click="disarm"
                    style="width: 76px"
                    color="warning"
                    >Disarm</vs-button
                  >
                </div>
              </div>
            </vs-col>
            <vs-col
              v-else
              class="center mt-4 mb-2"
              vs-lg="1"
              vs-sm="2"
              vs-xs="3"
            >
              <vs-icon
                icon="notifications_off"
                color="dark"
                size="75px"
              ></vs-icon>
            </vs-col>
            <vs-col
              class="mb-2 mt-2"
              vs-type="flex"
              vs-align="center"
              vs-lg="5"
              vs-sm="10"
              vs-xs="9"
            >
              <div id="divSizeResponsive" style="width: 100%">
                <vs-row vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Alert ID</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">{{ dataAlert.alertid }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Alert name</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">{{
                      dataAlert.alertname
                    }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Timestamp</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">
                      {{
                        $moment(dataAlert.timestamp).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      }}</span
                    >
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Status</span
                    >
                  </vs-col>
                  <vs-col
                    class="p-0"
                    v-if="dataAlert.alertstatus"
                    vs-lg="8"
                    vs-sm="8"
                    vs-xs="7"
                  >
                    <span id="textSizeResponsive">Armed</span>
                  </vs-col>
                  <vs-col v-else class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">Disarmed</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="5"
                  >
                    <span
                      class="font-weight-bold noWrap"
                      id="textSizeResponsive"
                      >Condition</span
                    >
                  </vs-col>
                  <vs-col class="p-0" vs-lg="8" vs-sm="8" vs-xs="7">
                    <span id="textSizeResponsive">{{ dataAlert.message }}</span>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-row>
      <vs-row>
        <vs-card style="border-radius: 20px">
          <vs-row>
            <h5 id="center" class="mt-2 mr-2">Sensor :</h5>
            <h5>
              <vs-button
                @click="viewSensor"
                icon="signal_cellular_alt"
                type="flat"
                >{{ dataAlert.sensorid }} {{ dataAlert.sensorname }}</vs-button
              >
            </h5>
          </vs-row>
          <br />
          <h6 class="mb-2">Reading Data</h6>
          <vs-table :data="Object.keys(dataAlert.lastdata[0])">
            <template slot="thead">
              <vs-th
                v-for="(data, index) in Object.keys(dataAlert.lastdata[0])"
                :key="index"
                >{{ data }}</vs-th
              >
              <vs-th
                style="width: 500px"
                v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
              >
              </vs-th>
              <vs-th v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
              </vs-th>
              <vs-th v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
              </vs-th>
              <vs-th v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
              </vs-th>
              <vs-th v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
              </vs-th>
            </template>
            <template>
              <vs-tr>
                <vs-td
                  v-for="data in Object.keys(dataAlert.lastdata[0])"
                  :key="data"
                >
                  {{ dataAlert.lastdata[0][data] }}
                </vs-td>
                <vs-td
                  style="width: 500px"
                  v-if="Object.keys(dataAlert.lastdata[0]).length <= 5"
                >
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
                <vs-td v-if="Object.keys(dataAlert.lastdata[0]).length <= 5">
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-row>
    </div>
    <b-modal id="modal-lg" size="lg" title="Large Modal"
      >Hello Large Modal!</b-modal
    >
    <vs-prompt color="primary" title="Work Detail" :active.sync="activePrompt2">
      <vs-progress :percent="viewpercentage" color="success"
        >success</vs-progress
      ><br />
      Work Progress {{ viewpercentage }}% Completed!<br /><br />
      <vs-row>
        <vs-col vs-lg="6">
          <p v-if="viewwork" style="font-size: 120%">
            Started by: {{ viewwork.username }}<br />
            Asset: -<br />
            Work detail: {{ viewwork.detail }}<br />
            Created Date: {{ viewwork.timestamp }}<br />
            Last edited: {{ viewwork.editdate }}<br />
            Time Spent: {{ viewwork.timespent }}
          </p>
        </vs-col>
        <vs-col vs-lg="6">
          <p v-if="viewwork" style="font-size: 120%">
            Plan Date: {{ viewwork.plandate }}<br />
            Actual start date: {{ viewwork.startdate }}<br />
            Finish date: {{ viewwork.finishtime }}<br />
            Status: {{ viewwork.iscomplete }}<br />
            WO Status :
          </p>
        </vs-col>
        <vs-divider></vs-divider>
      </vs-row>
      <FormRenderer :form-configuration="formData" v-model="formInputData" />
    </vs-prompt>
  </div>
</template>

<script>
import { FormRenderer } from "v-form-builder";
export default {
  name: "ViewAlert",
  props: ["user", "data"],
  components: {
    FormRenderer,
  },
  data: () => ({
    userAcc: "",
    id: "",
    viewpercentage: 0,
    descriptionItems: [10, 20],
    a: ["Open", "Successful"],
    b: [
      "Test AlertTest Alert",
      "Temperature > 25",
      "Office Temp",
      "26C",
      "2020-8-13 16:23:45",
      "Armed",
    ],
    controlstatus: [
      { name: "ON -> OFF", value: false },
      { name: "OFF -> ON", value: true },
    ],
    status: [
      { name: "Fail", value: false },
      { name: "Successful​", value: true },
    ],
    testmode: "Unavailable",
    sensname: [],
    formData: null,
    formInputData: null,
    actionselect: [],
    actionlist: [
      { name: "E-mail", detail: "", status: "" },
      { name: "LINE", detail: "", status: "" },
      { name: "SMS", detail: "", status: "" },
      { name: "Control", detail: "", status: "Please Select Status" },
      { name: "Work Order", detail: "", status: "" },
    ],
    params1: "",
    name: "",
    activePrompt: false,
    activePrompt2: false,
    viewwork: null,
    input: [],
    checkarray: [],
    typeselect: "Type Select",
    maingroup: [{ group: "Battery Level" }, { group: "Device Inactivity" }],
    sensorread: [],
    // powertype: ["VoltageL1","VoltageL2","VoltageL3","TotalPhaseVoltage","CurrentL1","CurrentL2","CurrentL3","TotalCurrent",
    //             "VoltageL1L2","VoltageL2L3","VoltageL3L1","TotalPtoPVoltage","ActivePowerL1","ActivePowerL2","ActivePowerL3","TotalActivePower",
    //             "ReactivePowerL1","ReactivePowerL2","ReactivePowerL3","TotalReactivePower","ApparentPowerL1","ApparentPowerL2","ApparentPowerL3","TotalApparentPower",
    //             "PowerFactorL1","PowerFactorL2","PowerFactorL3","TotalPowerFactor","Frequency","TotalimpActiveEnergy","TotalexportedActiveEnergy",
    //             "TotalimpReactiveEnergy","TotalexpReactiveEnergy","TotalApparentEnergy"],
    sencon: [["Greater Than", "Less Than"]],
    address: [[]],
    thenlist: ["E-mail", ""],
    pt: "Type",
    unit: ["Celcius", "Fahrenheit"],
    value: "",
    options2: [
      { text: "E-Mail", value: 1 },
      { text: "LINE Notification", value: 2 },
    ],
    then: "",
    users: [
      { email: "napat@swd.co.th", name: "Pao1" },
      { email: "sountorn@swd.co.th", name: "Pao2" },
      { email: "pao@swd.co.th", name: "Pao3" },
      { email: "napat2@swd.co.th", name: "Pao4" },
    ],
    selected: [],
    sensorlist: [],
    flitersensor: [[{ name: "Select Sensor Type First!" }]],
    conditionlist: [{ id: 1, type: "", sensid: "", con: "", value: "" }],
    tempsensorread: [],
    controlunit: [],
    formlist: [],
    mode: "",
    dataAlert: "",
    dataIdSensor: "",
    detail: "",
    viewAlert: [],
    admin: "",
  }),
  methods: {
    switchMap() {
      this.$router.push({ path: "/map?mapid=103" });
    },
    switchlocation() {
      this.$router.push({ path: "/location?locid=1" });
    },
    disarm() {
      console.log("disarm/user/" + this.dataAlert.actionid);
      if (this.userAcc != "yamahademo") {
        this.$API
          .get("disarm/user/" + this.dataAlert.actionid)
          .then(() => {
            this.$router.push({ path: "/IndoorAlert" });
          })
          .catch((err) => {
            console.log(err);
            this.$vs.notify({
              title: "Disarm Error!",
              text: "Can't disarm this alert",
              color: "danger",
              position: "top-center",
              icon: "check",
            });
          });
      } else {
        console.log('this.dataAlert',this.dataAlert.alertid);
        this.$store.dispatch('noti/disAlert',this.dataAlert.alertid);
        setTimeout(() => {
          this.$router.push(-1)
        }, 1000)
      }
    },
    viewSensor() {
      console.log(this.dataAlert);
      console.log(this.dataIdSensor);
      this.$API.get("sensors/user").then((result) => {
        let sensor = result.data.filter(
          (sensor) => sensor.id == this.dataAlert.sensorid
        );
        if (sensor) {
          let item = sensor[0];
          this.$session.set("nwname", item.network);
          this.$session.set("statussensor", item.active);
          this.$session.set("nwid", item.nwid);
          this.$session.set("sensorname", item.name);
          this.$session.set("sensorid", item.serial_id);
          this.$session.set("gatewayid", item.gatewayid);
          this.$session.set("type", item.type);
          this.$session.set("lora", item.lora);
          this.$session.set("id", item.id);
          this.$router.push({
            name: "SensorDashboard",
            params: {
              // nwname: sensor.network,
              nwid: item.nwid,
              sensorid: item.serial_id,
              gatewayid: item.gatewayid,
              type: item.type,
              id: item.id,
            },
          });
        }
      });
    },
    pop() {
      this.flitersensor.pop();
      this.sencon.pop();
      this.conditionlist.pop();
    },
    addnewsens() {
      this.flitersensor.push([{ name: "Select Sensor Type First!" }]);
      this.sencon.push(["Greater Than", "Less Than"]);
      this.conditionlist.push({
        id: this.conditionlist.length + 1,
        type: "",
        sensid: "",
        con: "",
        value: "",
      });
    },
    change() {
      // eslint-disable-next-line no-console
      // console.log(this.then)
    },
    sensorchange(item, i) {
      // console.log(item,i)
      while (this.address[i].length > 0) {
        this.address[i].pop();
      }
      var lastdata;
      this.flitersensor[i].forEach((element) => {
        if (item == element.id) {
          lastdata = JSON.parse(element.lastdata[0]);
          // console.log(lastdata)
          Object.keys(lastdata).forEach((keys) => {
            switch (keys) {
              case "p1v00r0000x10":
                this.address[i].push({ name: "Total Flow", value: keys });
                break;
              case "p1v00r0000x14":
                this.address[i].push({
                  name: "Reverse Total Flow",
                  value: keys,
                });
                break;
              case "ai1":
                this.address[i].push({ name: "PH", value: keys });
                break;
            }
          });
        }
      });
    },
    view(item) {
      this.viewpercentage = 0;
      var maxitem = 0;
      var nullitem = 0;
      // console.log(item)
      this.formData = item.form;
      this.viewwork = item;
      this.activePrompt2 = true;
      setTimeout(() => {
        this.formInputData = item.inputdata;
        // console.log(this.formInputData)
        if (item.inputdata) {
          Object.keys(item.inputdata).forEach((element) => {
            maxitem += 1;
            if (
              item.inputdata[element] == null ||
              item.inputdata[element] == 0 ||
              item.inputdata[element] == ""
            ) {
              nullitem += 1;
            }
          });
          this.viewpercentage = (
            [(maxitem - nullitem) / maxitem] * 100
          ).toFixed(2);
        }
      }, 200);
    },
    actionchange(item, i) {
      while (this.flitersensor[i].length > 0) {
        this.flitersensor[i].pop();
      }
      this.sensorlist.forEach((element) => {
        if (element.type == "monnit") {
          if (element.subtype == item) {
            this.flitersensor[i].push(element);
          }
        } else if (element.type != null && element.type != "") {
          if (element.type == item) {
            this.flitersensor[i].push(element);
          }
        }
      });
      switch (item) {
        case "Humidity":
          this.sencon[i] = [
            "Humidity Greater Than (%)",
            "Humidity Less Than (%)",
            "Greater Than (°C)",
            "Less Than (°C)",
            "Greater Than (°F)",
            "Less Than (°F)",
          ];
          break;
        case "Temperature":
          this.sencon[i] = [
            "Greater Than (°C)",
            "Less Than (°C)",
            "Greater Than (°F)",
            "Less Than (°F)",
          ];
          break;
        case "Vibration":
          this.sencon[i] = ["Greater Than", "Less Than"];
          break;
        case "CT":
          this.sencon[i] = ["Amp Greater Than", "Amp Less Than"];
          break;
        case "control":
        case "O/C":
          this.sencon[i] = ["True", "False"];
          break;
        case "powermeter":
          this.sencon[i] = [
            "Amp Greater Than",
            "Amp Less Than",
            "Volt Greater Than",
            "Volt Less Than",
          ];
          break;
      }
    },
    clear() {
      this.actionselect = "Action Select";
      this.typeselect = "Type Select";
      this.con = "Greater Than";
      this.pt = "Type";
      this.value = "";
    },
    // send() {
    //   // console.log(this.conditionlist,this.actionlist)
    // }
    send() {
      switch (this.mode) {
        case "edit":
          this.$API.post("updateaction", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            id: this.id,
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            token: this.$session.get("token"),
          });
          this.$vs.notify({
            title: "Add Alert",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            this.$router.push({ name: "Action" });
          }, 1000);
          break;
        case "create":
          this.$API.post("action", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            token: this.$session.get("token"),
          });
          this.$vs.notify({
            title: "Add Alert",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            this.$router.push({ name: "Action" });
          }, 1000);
          break;
      }
    },
  },
  beforeDestroy() {
    this.$session.remove("action");
    this.$session.remove("actiondetail");
  },
  async created() {
    this.params1 = this.$route.params.test;
    this.mode = this.$session.get("action");
    this.detail = this.$session.get("actiondetail");
    this.dataAlert = this.$session.get("dataAlert");
    this.dataIdSensor = this.$session.get("dataIdSensor");
    this.userAcc = this.$session.get("username");
    console.log(this.mode);
    console.log(this.detail);
    console.log(this.dataAlert);
    console.log(this.dataIdSensor);
    console.log(this.userAcc);
    console.log(this.dataAlert, this.dataIdSensor);
    if (this.dataAlert == null) {
      this.dataAlert = {};
      await this.$API.get("alertlog/user").then((result) => {
        result.data.forEach((element) => {
          if (this.$route.params.alertId == element.id) {
            element.alerthistory.forEach((el) => {
              if (this.$route.params.historyId == el.historyId) {
                this.dataAlert = el;
                this.dataAlert.alertid = el.historyId;
                this.dataAlert.alertname = element.alertname;
                this.dataAlert.alertstatus = el.alertstatus;
                this.dataAlert.sensorname = element.sensorname;
                this.dataAlert.sensorid = sensor[0].id;
              }
            });
          }
        });
      });
    }
    await this.$API.get("getform/user").then((result) => {
      this.formlist = result.data;
    });
    var check = false;
    await this.$API.get("sensors/user").then((result) => {
      this.sensorlist = result.data;
      // console.log(this.sensorlist)
      result.data.forEach((element) => {
        if (element.type == "control" || element.type == "Control")
          this.controlunit.push(element);
        if (element.type == "monnit") {
          check = false;
          this.sensorread.forEach((element2) => {
            if (element2 == element.subtype) check = true;
          });
          if (!check) {
            this.sensorread.push(element.subtype);
            check = false;
          }
        } else if (element.type != null && element.type != "") {
          this.sensorread.forEach((element2) => {
            if (element2 == element.type) check = true;
          });
          if (!check) {
            this.sensorread.push(element.type);
            check = false;
          }
        }
      });
      if (this.mode == "edit") {
        // console.log(this.detail)
        this.id = this.detail.id;
        this.name = this.detail.name;
        this.conditionlist = [];
        this.detail.con.forEach((element, i) => {
          this.conditionlist.push(element);
        });
        this.conditionlist.forEach((element, i) => {
          this.sensorlist.forEach((sensor) => {
            if (sensor.name == element.sensid) {
              element.sensid = sensor.id;
            }
          });
          this.flitersensor.push([{ name: "Select Sensor Type First!" }]);
          this.sencon.push(["Greater Than", "Less Than"]);
          this.actionchange(element.type, i);
        });
        setTimeout(() => {
          this.conditionlist = [];
          this.detail.con.forEach((element) => {
            this.conditionlist.push(element);
          });
          // console.log(this.conditionlist,this.flitersensor)
        }, 500);
        this.actionlist = this.detail.action;
        // console.log(this.detail.action)
        // console.log(this.formlist)
        this.actionlist.forEach((element) => {
          this.formlist.forEach((form) => {
            if (
              element.name == "Work Order" &&
              element.detail == form.conf.formConfig.headline
            ) {
              element.detail = form.conf;
            }
          });
          if (element.status == "ON -> OFF") element.status = false;
          else if (element.status == "OFF -> ON") element.status = true;
        });
      }
    });
  },
  mounted() {
    this.admin = this.$session.get("admin")
    switch (this.userAcc || this.admin) {
      case "betagrodemo":
        console.log("betagrodemo");
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
        });
        var elemselect = document.getElementsByClassName("vs-card--content");
        Array.prototype.filter.call(elemselect, function (testElementselect) {
          // testElementselect.style.background = "#484848";
          testElementselect.style.color = "#ffffff";
        });
        var elemtable = document.getElementsByClassName("headerText");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.color = "#ffffff";
        });
        var elemtable2 = document.getElementsByClassName("vs__search");
        Array.prototype.filter.call(elemtable2, function (testElementtable2) {
          testElementtable2.style.background = "#ffffff";
        });
        var elemtable3 = document.getElementsByClassName("vs-button");
        Array.prototype.filter.call(elemtable3, function (testElementtable3) {
          testElementtable3.style.color = "#32c040";
        });
        var elemtable7 = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable7, function (testElementtable7) {
          testElementtable7.style.background = "#212121";
        });
        var elemtableheader8 =
          document.getElementsByClassName("vs-table--header");
        Array.prototype.filter.call(
          elemtableheader8,
          function (testElementtableheader8) {
            testElementtableheader8.style.background = "#212121";
          }
        );
        var elemtableul9 = document.getElementsByClassName("vs-pagination--ul");
        Array.prototype.filter.call(
          elemtableul9,
          function (testElementtableul9) {
            testElementtableul9.style.background = "none";
          }
        );
        document.getElementById("myDiv").style.paddingBottom = "1000px";
        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
};
</script>
<style scoped>
/* .vs-button-danger.vs-button-border, .vs-button-danger.vs-button-flat {
    background: rgba(var(--vs-danger),.08)!important;
} */
.noWrap {
  white-space: nowrap;
}
.vs-button {
  border-radius: 20px;
}
#textSuccess {
  color: #32c040;
}
.center {
  text-align: center;
}
.textRight {
  text-align: right;
  padding-right: 50px;
}

@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
  /* #textSizeResponsive{
    font-size: 0.775rem
  } */
  #divSizeResponsive {
    padding: 10px;
  }
}

.th {
  padding: 0%;
}
.border1 {
  padding: 0px;
  border-style: solid;
  border-width: 1px;
}
.border:hover {
  height: 0px;
  transition: 1000s;
}
.vs-table--thead {
  z-index: 200;
  width: 100%;
  position: static;
}
</style>
